import { useEffect } from 'react';

import { getCoreUITokenValues } from '../../../util/theme/fluent9/coreUITokens';
import type { OverridableCoreUITokens } from '../../../util/theme/fluent9/coreUITokens.types';

type UseSetBodyCoreUITokenStyles = (
  isDarkMode: boolean,
  themeCoreUITokenOverrides: OverridableCoreUITokens | undefined
) => void;

/**
 * Sets CoreUI token values as inline CSS custom properties (variables) directly on the body element.
 * This follows Fluent UI 9's pattern of setting design tokens as inline styles.
 *
 * The inline styles approach eliminates CSS cascade conflicts that can occur when using
 * CSS classes with global selectors in FluentUI's mergeStyleSets.
 *
 * @param isDarkMode - Whether dark mode is active
 * @param themeCoreUITokenOverrides - Optional overrides for specific token values (e.g., brand colors)
 */
export const useSetBodyCoreUITokenStyles: UseSetBodyCoreUITokenStyles = (isDarkMode, themeCoreUITokenOverrides) => {
  useEffect(() => {
    const tokenValues = getCoreUITokenValues(isDarkMode, themeCoreUITokenOverrides);

    Object.entries(tokenValues).forEach(([cssVar, value]) => {
      document.body.style.setProperty(cssVar, value);
    });
  }, [isDarkMode, themeCoreUITokenOverrides]);
};
